import { AnimationBaseController, AnimationTextStyle, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';
import { getCommonConfig } from '../../Common/GameConfig';
import { COIN64 } from '../../Constants/ImageConstants';
import { GameModel } from '../../Models/GameModel';

export class UIScoreController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: any) {
        super('UIScoreController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        
        return <IAnimationControllerConfiguration>{
            modelWatch: {
                playerDistance: (value: number) => {
                    this.updateCoins()

                },
                levelCoins: () => this.updateCoins(),

            }
        };
    }

    private updateCoins(): void {
        let coins = this.$model.levelCoins + this.$model.playerDistance * getCommonConfig('coinPerDistance');
        coins = Math.floor(coins);
        // let k = '';
        // while (coins > 9999) {
        //     coins /= 1000;
        //     k += 'k';
        // }


        this.setTextByQuery('txt_score', this.$model.generator.trackIndex + ` <coin> </coin> ` + coins + ' ');
    }

    protected onInitialize(): void {
        // this.setTextByQuery('txt_score', this.$model.gasStationCheckedCount.toString());
        this.updateCoins();
        const coin64: AnimationTextStyle = {
            imgSrc: COIN64,
            height: 56,
            width: 58,
            valign: "middle",
            padding: 10,
            fontSize: 64,
        }

        this.setTextStyleByQuery("txt_score", { valign: "middle" }, {
            coin: coin64
        })
        this.setTextVerticalAlignByQuery('txt_score', "middle");
    }

    protected onResize(width: number, height: number, scale: number) {
        // this.scaleX = this.scaleY = 1.5;
    }
}
